exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-normal {\n  padding: 5px 0px;\n  display: block; }\n  .logo-normal img {\n    width: 130px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/main/sidebar/sidebar.component.scss
// module id = ../../../../../src/app/client/components/main/sidebar/sidebar.component.scss
// module chunks = 0